import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const PermissionRoute = ({ element, requiredPermission }) => {
  const { currentUser, userData, loading } = useAuth();

  if (loading) return <p className="centered-text">Cargando...</p>;

  if (!currentUser) return <Navigate to="/admin/login" />;

  if (userData?.role === 'admin') return element;

  if (userData?.role === 'employee' && userData?.permissions?.includes(requiredPermission)) {
    return element;
  }

  return <Navigate to="/" />;
};

export default PermissionRoute;

